angular.module('impactx.purchaseorder').controller('PurchaseOrderItemListCtrl', ['selectedListItems', 'DownloadService', '$scope',
    PurchaseOrderItemListCtrl]);

function PurchaseOrderItemListCtrl(selectedListItems, DownloadService, $scope) {
    var ctrl = this;

    this.isPOHSelectionUnique = function () {
        var selectedPOHs = [];
        angular.forEach(selectedListItems.getSelectedItems(), function(item) {
            if (!selectedPOHs.includes(item.pohId)){
                selectedPOHs.push(item.pohId)
            }
        });
        return selectedPOHs.length == 1;
    };

    this.getDetailsLink = function () {
        return "purchaseorderdetail/" + selectedListItems.getFirstSelectedItem().pohId;
    };

    this.showCreateDelNoteButton = function () {
        return ctrl.isPOHSelectionUnique() && !selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    this.getDeliveryNoteLink = function () {
        return "deliverynote/" + selectedListItems.getFirstSelectedItem().pohId;
    };

    this.canCreateSPOReportAsExcel = function () {
        return selectedListItems.isNoSelection() && $scope.$$childHead.data.actions.canCreateSPOReportAsExcel.allowed;
    };

    this.createSPOReportAsExcel = function () {
        DownloadService.openDownloadPost('/subsequentpurchaseorderdata/export/report', {paramName: "config", paramValue: $scope.$$childHead.metaData.params.listConfig});
    };

    var buttonDefinition = [
        {
            label: "createSPOReportAsExcel",
            action: ctrl.createSPOReportAsExcel,
            condition: ctrl.canCreateSPOReportAsExcel,
        },
        {
            label: "details",
            linkFunction: ctrl.getDetailsLink,
            type: 'link',
            condition: ctrl.isPOHSelectionUnique,
            process: 'PurchaseOrderView'
        },
        {
            label: "createDelNote",
            linkFunction: ctrl.getDeliveryNoteLink,
            type: 'link',
            condition: ctrl.showCreateDelNoteButton,
            process: 'EditDeliveryNote'
        },
    ];

    this.meta = {
        rowTemplate: 'modules/purchaseorder/templates/purchaseorderitemlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/purchaseorder/itemlist',
        ctrl: this,
        id: "purchaseorderitemlist",
        totalList: {url: "purchaseorderlist", disabled: false, translationKey: "orderList"},
        singleList: {url: "purchaseorderitemlist", disabled: true, translationKey: "orderPositionList"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}